import { render, staticRenderFns } from "./pain.vue?vue&type=template&id=fe4a161a&scoped=true"
import script from "./pain.vue?vue&type=script&lang=js"
export * from "./pain.vue?vue&type=script&lang=js"
import style0 from "./pain.vue?vue&type=style&index=0&id=fe4a161a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4a161a",
  null
  
)

export default component.exports